import { UserService } from 'app/services/user.service';
import { NativeService } from './../../../services/native.service';
import { SelectListComponent } from './select-list.component';
import { FieldModel } from 'app/models/shared/field.model';
import { VehicleModel } from 'app/models/dms/vehicle.model';
import { GeneralService } from 'app/services/general.service';
import { LookupType, LookupExternalCollection, LookupInternalCollection, VehicleClass, SecurityRight, LookupExtImageCollection } from 'app/utility/enums';
import { SelectListModalComponent } from './select-list-modal.component';
import { Component, OnInit, OnChanges, EventEmitter, Input, Output, ChangeDetectorRef } from '@angular/core';

import { ListItemModel } from 'app/models/shared/listItem.model';
import { Constants } from 'app/utility/constants';
import { ModalController, LoadingController } from '@ionic/angular';


@Component({
    selector: 'app-select-list-lazy',
    templateUrl: './select-list-lazy.component.html',
    styleUrls: ['./select-list-lazy.component.scss'],
    standalone: false
})
export class SelectListLazyComponent extends SelectListComponent implements OnInit
{

	/* lazyload list usage */
	@Input() id: string = '';
	@Input() parentId: string;
	@Input() field: FieldModel;
	@Input() showBoxes: boolean = false;

	/* vehicle specific select*/
	@Input() detailClass: VehicleClass;

	private currentParentId: string;

	private useLookupId: boolean = false; //force internal lookups to use id not member
	public hidden: boolean = false;

	constructor(public modalController: ModalController,
		protected nativeService: NativeService,
		public generalService: GeneralService,
		public userService: UserService,
		protected cd: ChangeDetectorRef,
	)
	{
		super(modalController, nativeService, cd, generalService);
		this.displayType = 'compact';
	}

	ngOnInit()
	{
		if (this.sideload && (!this.items || this.items.length == 0))
		{
			//fetch the lookup
			// console.log('Fetch the lookup', this.sideload);

			//first, setup the selected value

			this.loadLookupItems();

			if (this.sideload.lookupType == LookupType.External && this.sideload.canAddNewValues)
			{
				this.canAddNew = true;
			}

		}
		else
		{
			throw new Error("Missing sideload object on " + this.label);
		}

		this.currentParentId = this.parentId;

		// this.configureSelectedItem();
	}

	private async loadLookupItems(clearCache: boolean = false, loadModal: boolean = false)
	{
		if (this.loading)
		{
			return;
		}

		if (clearCache)
		{
			this.field.clearCache = true;
		}

		var item: ListItemModel;
		this.items = [];
		if (this.sideload.lookupType == LookupType.External)
		{
			// console.log("External", this.sideload.id);
			this.lookupType = LookupType.External;
			this.lookupCollection = this.sideload.collection;
			item = new ListItemModel(this.sideload.id, this.sideload.caption ? this.sideload.caption : "-");
			item._class = item.name ? item.name.toLowerCase().replace(/[^a-z]/g, '').replace(/ /g, '-') : '';
			this.selectedItem = item;
			this.items.push(item);
			this.configureSelectedItem();

			//now, fetch the lookups
			this.loading = true;
			this.cd.detectChanges();
			// console.log(this.sideload);
			var parentId = (this.parentId == Constants.EmptyGuid) ? Constants.SearchEmptyGuid : this.parentId;
			// console.log(this.parentId);
			this.generalService.getCachedExternalLookups(this.detailClass ? this.detailClass : VehicleClass.None, <LookupExternalCollection>this.lookupCollection, (this.field.preventParentIdInLookup ? null : parentId), this.field.clearCache, this.field.includeNone, this.field.noneLabel)
				.subscribe
				({
					next: x =>
					{
						// console.log(this.lookupCollection, item.id, x);
						this.items = x.map<ListItemModel>(y => new ListItemModel(y.id.toString(), y.caption));
						this.configureSelectedItem();

						if (this.field.clearCache)
						{
							this.field.clearCache = false;
						}
						//if lookupInternal and min version is 3.2.14
						if (this.sideload.lookupInternal && this.userService.mcMinVersion("3.2.14"))
						{
							this.loadBaseInternalLookup(loadModal);
						}
						else if (loadModal)
						{
							this.showModal();
						}
						setTimeout(() =>
						{
							this.loading = false;
							this.cd.detectChanges();
						}, 0);
					},
					error: err =>
					{

						setTimeout(() =>
						{
							this.loading = false;
							this.cd.detectChanges();
						}, 0);
						console.error(`getCachedExternalLookups`, err);
					}
                });
		}
		else if (this.sideload.lookupType == LookupType.Internal)
		{
			// console.log("Internal", this.sideload.id);
			this.lookupType = LookupType.Internal;
			this.lookupCollection = this.sideload.collection;
			if (this.selectedItemId == null) this.selectedItemId = "0";
			this.useLookupId = (this.field.useIdsInInternalLookup || (typeof (this.selectedItemId) == "string" && this.selectedItemId.includes("-")));
			if (this.useLookupId)
			{
				// console.log("List uses IDs for internal lookup", this.field.id);
				this.field.useIdsInInternalLookup = true;
			}
			item = new ListItemModel(this.useLookupId ? this.sideload.id.toString() : this.sideload.member.toString(), this.sideload.caption ? this.sideload.caption : "-");
			this.items.push(item);
			this.selectedItem = item;
			//now, fetch the lookups
			this.loading = true;
			this.generalService
				.getInternalLookups(<LookupInternalCollection>this.lookupCollection, this.field.includeNone, this.field.noneLabel)
				.subscribe
				({
					next: x =>
					{
						this.items = x.map<ListItemModel>(y => new ListItemModel(this.useLookupId ? y.id.toString() : y.member.toString(), y.caption));
						if (this.field.exclude && this.field.exclude.length > 0)
						{
							var exclude = this.field.exclude;
							this.items = this.items.filter(function (w)
							{
								var index = exclude.indexOf("" + w.id);
								return (index < 0);
							});
						}
						this.configureSelectedItem();

						setTimeout(() =>
						{
							this.loading = false;
							this.cd.detectChanges();
						}, 0);
					},
					error: err =>
					{

						setTimeout(() =>
						{
							this.loading = false;
							this.cd.detectChanges();
						}, 0);
						console.error(`getInternalLookups`, err);
					}
                });
			// console.log(this.items);
		}
		else if (this.sideload.lookupType == LookupType.ExtImage)
		{
			this.lookupType = LookupType.ExtImage;
			this.lookupCollection = this.sideload.collection;
			item = new ListItemModel(this.sideload.id, this.sideload.caption ? this.sideload.caption : "-");
			item._class = item.name ? item.name.toLowerCase().replace(/[^a-z]/g, '').replace(/ /g, '-') : '';
			this.selectedItem = item;
			this.items.push(item);
			this.configureSelectedItem();

			//now, fetch the lookups
			this.loading = true;
			this.cd.detectChanges();
			var parentId = (this.parentId == Constants.EmptyGuid) ? Constants.SearchEmptyGuid : this.parentId;

			this.generalService.getCachedExtImageLookups(<LookupExtImageCollection>this.lookupCollection, (this.field.preventParentIdInLookup ? null : parentId), this.field.clearCache)
			.subscribe
			({
				next: x =>
					{
						// console.log(this.lookupCollection, item.id, x);
						this.items = x.map<ListItemModel>(y => new ListItemModel(y.id.toString(), y.caption));
						this.configureSelectedItem();

						if (this.field.clearCache)
						{
							this.field.clearCache = false;
						}

						if (loadModal)
						{
							this.showModal();
						}
						setTimeout(() =>
						{
							this.loading = false;
							this.cd.detectChanges();
						}, 0);
					},
					error: err =>
					{

						setTimeout(() =>
						{
							this.loading = false;
							this.cd.detectChanges();
						}, 0);
						console.error(`getCachedExtImageLookups`, err);
					}
            })
		}
	}


	protected configureSelectedItem()
	{
		if (this.selectedItemId && this.items)
		{
			for (let itemIndex in this.items)
			{
				let item = this.items[itemIndex];
				item._class = item.name ? item.name.toLowerCase().replace(/[^a-z]/g, '').replace(/ /g, '-') : '';
				if (item.id == this.selectedItemId)
				{
					this.selectedItem = item;
				}
			}
		}
	}

	show(refresh: boolean = false): void
	{
		if (this.loading)
		{
			return;
		}

		if (this.items.length == 0 || this.parentId && this.parentId != this.currentParentId)
		{
			if (this.parentId && this.parentId != this.currentParentId)
			{
				// console.log("Parent ID is different!", this.parentId, this.currentParentId);
				this.currentParentId = this.parentId;
				this.clearSelectedItem();
			}

			if (this.parentId && this.field.toggleEditableWhen && this.field.toggleEditableWhen != '')
			{
				if (this.field.toggleEditableWhen == this.parentId)
				{
					this.hidden = false;
				}
				else
				{
					this.hidden = true;
				}
			}

			if (this.sideload.lookupType == LookupType.External)
			{
				// console.log("looking up external");
				this.allowRefresh = true;
				this.lookupType = LookupType.External;
				this.lookupCollection = this.sideload.collection;
				//now, fetch the lookups
				this.loading = true;
				var parentId = (this.parentId == Constants.EmptyGuid) ? Constants.SearchEmptyGuid : this.parentId;
				// console.log(this.parentId);
				this.generalService.getCachedExternalLookups(this.detailClass, <LookupExternalCollection>this.lookupCollection, (this.field.preventParentIdInLookup ? null : parentId), refresh, this.field.includeNone, this.field.noneLabel)
					.subscribe
					({
						next: x =>
						{
							// console.log(this.lookupCollection, x);
							this.items = x.map<ListItemModel>(y => new ListItemModel(y.id.toString(), y.caption));
							this.configureSelectedItem();
							setTimeout(() =>
							{
								this.loading = false;
								this.cd.detectChanges();
							}, 0);

							setTimeout(() =>
							{
								this.showModal();
							}, 50);
						},
						error: err =>
						{
							setTimeout(() =>
							{
								this.loading = false;
								this.cd.detectChanges();
							}, 0);
							console.error(`getCachedExternalLookups`, err);
						}
                    })
			}
			else if (this.sideload.lookupType == LookupType.Internal)
			{
				this.allowRefresh = true;
				// console.log("Internal", this.sideload.id);
				this.lookupType = LookupType.Internal;
				this.lookupCollection = this.sideload.collection;
				if (this.selectedItemId == null) this.selectedItemId = "0";
				this.useLookupId = (this.field.useIdsInInternalLookup || (typeof (this.selectedItemId) == "string" && this.selectedItemId.includes("-")));
				if (this.useLookupId)
				{
					// console.log("List uses IDs for internal lookup", this.field.id);
					this.field.useIdsInInternalLookup = true;
				}
				var item: ListItemModel;
				item = new ListItemModel(this.useLookupId ? this.sideload.id.toString() : this.sideload.member.toString(), this.sideload.caption ? this.sideload.caption : "-");
				this.items.push(item);
				this.selectedItem = item;
				//now, fetch the lookups
				this.loading = true;
				this.generalService
					.getInternalLookups(<LookupInternalCollection>this.lookupCollection, this.field.includeNone, this.field.noneLabel)
					.subscribe
					({
						next: x =>
						{
							this.items = x.map<ListItemModel>(y => new ListItemModel(this.useLookupId ? y.id.toString() : y.member.toString(), y.caption));
							if (this.field.exclude && this.field.exclude.length > 0)
							{
								var exclude = this.field.exclude;
								this.items = this.items.filter(function (w)
								{
									var index = exclude.indexOf("" + w.id);
									return (index < 0);
								});
							}
							this.configureSelectedItem();
							setTimeout(() =>
							{
								this.loading = false;
								this.cd.detectChanges();
							}, 0);
						},
						error: err =>
						{
							setTimeout(() =>
							{
								this.loading = false;
								this.cd.detectChanges();
							}, 0);
							console.error(`getInternalLookups`, err);
						}
                    });
				// console.log(this.items);
			}
			else if (this.sideload.lookupType == LookupType.ExtImage)
			{
				// console.log("looking up ext image");
				this.allowRefresh = true;
				this.lookupType = LookupType.ExtImage;
				this.lookupCollection = this.sideload.collection;
				//now, fetch the lookups
				this.loading = true;
				var parentId = (this.parentId == Constants.EmptyGuid) ? Constants.SearchEmptyGuid : this.parentId;
				// console.log(this.parentId);
				this.generalService.getCachedExtImageLookups(<LookupExtImageCollection>this.lookupCollection, (this.field.preventParentIdInLookup ? null : parentId), refresh)
					.subscribe
					({
						next: x =>
						{
							// console.log(this.lookupCollection, x);
							this.items = x.map<ListItemModel>(y => new ListItemModel(y.id.toString(), y.caption));
							this.configureSelectedItem();
							setTimeout(() =>
							{
								this.loading = false;
								this.cd.detectChanges();
							}, 0);

							setTimeout(() =>
							{
								this.showModal();
							}, 50);
						},
						error: err =>
						{
							setTimeout(() =>
							{
								this.loading = false;
								this.cd.detectChanges();
							}, 0);
							console.error(`getCachedExtImageLookups`, err);
						}
                    })
			}
		}
		else
		{
			this.showModal();
		}
	}

	allowRefresh: boolean = false;

	async showModal()
	{
		// console.log(this.field);
		var statusBarColor = this.nativeService.currentColor;
		this.nativeService.setupStatusBar("light");

		let allowAddCode = false;
		let codeCaption = '';
		let allowAddReference = false;
		let referenceCaption = '';
		let allowAddCustomField1 = false;
		let customField1Caption = '';

		if (this.sideload.allowAddCode)
		{
			allowAddCode = true;
			codeCaption = this.sideload.codeCaption ?? 'Item code';
		}
		if (this.sideload.allowAddReference)
		{
			allowAddReference = true;
			referenceCaption = this.sideload.referenceCaption ?? 'Item reference';
		}
		if (this.sideload.allowAddCustomField1)
		{
			allowAddCustomField1 = true;
			customField1Caption = this.sideload.customField1Caption ?? 'Custom field 1';
		}

		const modal = await this.modalController.create({
			component: SelectListModalComponent,
			componentProps: {
				'id': this.id,
				'title': this.label,
				'items': this.items,
				'selectAllLabel': this.selectAllLabel,
				'selectedValue': this.selectedValue,
				'selectedItemId': this.selectedItemId,
				'selectedItem': this.selectedItem,
				'displayType': this.displayType,
				'showBoxes': this.showBoxes,
				'allowRefresh': (this.lookupType == LookupType.External),
				'allowAdd': this.canAddNew,
				'allowClear': this.field.allowClear,
                'forceDisableAllowClear': this.field.forceDisableAllowClear,
				'codeLookupList': (this.codeLookupList && this.codeLookupList.length > 0 ? this.codeLookupList : null),
				allowAddCode,
				codeCaption,
				allowAddReference,
				referenceCaption,
				allowAddCustomField1,
				customField1Caption
			}
		});
		await modal.present();

		const { data } = await modal.onDidDismiss();
		this.nativeService.setupStatusBar(statusBarColor);
		// console.log(data);
		if (data && data.refresh)
		{
			this.loadLookupItems(true, true);
		}
        else if (data && data.clear)
        {
            this.clearSelectedItem();
        }
		else if (data && data.caption)
		{
			this.addNewLookup(data);
		}
		else if (data && data.selectedItem)
		{
			// console.log(data);
			this.setSelectedItem(data.selectedItem, true);
		}
	}

	protected async addNewLookup(data: any)
	{
		if (this.loading) return;

		// console.log(data);
		if (this.lookupType != LookupType.External)
		{
			throw `Add lookup for lookup type, ${this.lookupType}, not supported`;
		}

		console.debug(`Add new lookup`, data.caption);

		this.loading = true;
		this.cd.detectChanges();
		var parentId = (this.parentId == Constants.EmptyGuid) ? Constants.SearchEmptyGuid : this.parentId;
		this.generalService.findOrCreateExternalLookupCached(data.caption, this.detailClass ? this.detailClass : VehicleClass.None, <LookupExternalCollection>this.lookupCollection, (this.field.preventParentIdInLookup ? null : parentId), data.code ?? null, data.reference, data.customField1).subscribe({
			next: x =>
			{
				// console.debug(`findOrCreateExternalLookupCached`, x);
				const item = new ListItemModel(x.id, x.caption);
				this.items.push(item);
				this.setSelectedItem(item, true);
				this.sideload.id = x.id;
				this.sideload.caption = x.caption;
				this.selectedValue = x.caption;
				this.loadLookupItems(true, false);

				setTimeout(() =>
				{
					this.loading = false;
					this.cd.detectChanges();
				}, 0);
			},
			error: err =>
			{
				this.userService.handleError(err);
				setTimeout(() =>
				{
					this.loading = false;
					this.cd.detectChanges();
				}, 0);
				console.error(`Add new lookup failed`, data.caption);
			}
        });
	}

	setSelectedItem(item: ListItemModel, emit: boolean): void
	{
		if (this.selectedItem != item)
		{

			// console.log(this.sideload.lookupType);

			//  console.log(this.selectedItem);
			this.selectedItem = item;
			this.selectedItemId = item.id;
			if (this.field)
			{
				this.field.editValue = item.id;
				this.field.editCaption = item.name;
			}
			if (emit)
			{
				this.selectedItemIdChange.emit(item.id);
			}
		}

	}

	clearSelectedItem(): void
	{
		this.selectedItem = null;
		this.selectedItemId = Constants.EmptyGuid;

		this.setSelectedItem(this.selectedItem, false);

        this.cd.detectChanges();
	}

	defaultValue(): boolean
	{
		var defaultvalue = this.defaultItemId && this.defaultItemId !== '' && ((!this.selectedItem) || this.selectedItemId == this.defaultItemId);
		return defaultvalue;
	}

	getDisplayValue(): string
	{
		if (this.parentId != this.currentParentId)
		{
			return "-";
		}
		return (this.selectedItem) ? this.selectedItem.name : '-';
	}


	refreshing: boolean = false;
	async doRefresh(ev: any)
	{
		this.show(true);


		setTimeout(() =>
		{
			ev.target.complete();

		}, 1500);
	}

	itemHasValue()
	{
		if (this.parentId != this.currentParentId) return false;
		return (this.selectedItem && this.selectedItem.name != '' && this.selectedItem.name != '-');
	}
	scrollTop: boolean = true;
	ionScrollEvent(ev: any)
	{
		var scrollTop = (ev.detail.scrollTop == 0);
		if (this.scrollTop != scrollTop)
		{
			this.scrollTop = scrollTop;
		}
	}
}
